module.exports = __webpack_public_path__ + "media/images/onboarding-insights-eab91dcd.png";